/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".premium-anchor[_ngcontent-%COMP%]{border-left:1px solid rgba(255,184,34,.6)}.premium-anchor[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%]{border-color:#ffb822!important}.primary-anchor[_ngcontent-%COMP%]{border-left:1px solid rgba(53,163,247,.6)}.primary-anchor[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%]{border-color:#35a3f7!important}"];
export { styles as styles };
